<span [id]="id" class="arrow" [ngClass]="{'active': upWhenTrue}">
  <span></span>
  <span></span>
</span>
